import React, { useEffect, useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import LineChartIcon from "../../../../../assets/icons/line_chart_icon.svg";
import BarChartIcon from "../../../../../assets/icons/bar_chart_icon.svg";
import LineChartWhite from "../../../../../assets/icons/line_chart_white.svg";
import BarChartClr from "../../../../../assets/icons/bar_chart_color.svg";
import RefresIcon from "../../../../../assets/icons/refresh_icon.svg";
import useMediaQuery from "../../../../../hooks/useMediaQuery";
import DashboardDatePicker from "../DashboardDatePicker";
import { sendPostRequest } from "../../../../../actions/app-actions";
import { getAdminBusinessId } from "../../../../../utils/authHelper";
import { connect } from "react-redux";
import moment from "moment";
import Tooltip from "../../../../../components/Tooltip";
import ChartViewToggle from "../ChartViewToggle";

Chart.register(...registerables);

const SalesChart = (props) => {
  const [chartType, setChartType] = useState("bar");
  const [chartData, setChartData] = useState(null);
  const [renderChart, setRenderChart] = useState(false);
  const [isMonthlyView, setIsMonthlyView] = useState(true);
  const [filterYear, setFilterYear] = useState(new Date());
  const [data, setData] = useState([]);
  const isTablet = useMediaQuery("(min-width: 768px)");

  const buildChartData = (rawData, type) => ({
    labels: rawData.map((row) => row.index),
    datasets: [
      {
        label: "Revenue",
        data: rawData.map((d) => d.total),
        backgroundColor: "rgba(23, 137, 198, 0.15)",
        borderRadius: 6,
        borderWidth: type === "line" ? 2.5 : 0,
        borderColor: "#1789C6",
        tension: type === "line" ? 0.4 : 0,
        pointRadius: type === "line" ? (isTablet ? 4 : 2) : 0,
        pointBackgroundColor: "#1789C6",
        fill: type === "line",
      },
    ],
  });

  useEffect(() => {
    if (data.length > 0) {
      setChartData(buildChartData(data, chartType));
      setRenderChart(true);
    }
  }, [chartType]);

  useEffect(() => {
    loadChartData({ is_month_view: "E" });
  }, []);

  const loadChartData = (requestData = {}) => {
    const { sendPostRequest } = props;
    sendPostRequest({
      url: `/admin/event-sales-chart/${getAdminBusinessId()}`,
      data: requestData,
      onSuccess: function (response) {
        const { data: respData } = response;
        setData(respData.data);
        setChartData(buildChartData(respData.data, chartType));
        setRenderChart(true);
      },
      onError: function (error) {
        console.log("error", error);
      },
    });
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        min: 0,
        grid: { color: "rgba(0,0,0,0.04)", drawBorder: false },
        ticks: {
          font: { size: 12 },
          color: "#9a9fa5",
          callback: (value) => "$ " + value,
        },
        border: { display: false },
      },
      x: {
        grid: { display: false },
        ticks: {
          font: { size: 11 },
          color: "#9a9fa5",
        },
        border: { display: false },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#1a1d1f",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 12 },
        padding: 10,
        cornerRadius: 8,
        boxPadding: 4,
        callbacks: {
          label: (ctx) => `Revenue: $${ctx.parsed.y}`,
        },
      },
    },
  };

  return (
    <div className="chart-card">
      <div className="chart-card-header">
        <div className="chart-card-title">
          <h3>Revenue Overview <Tooltip code="P3F5" /></h3>
          <p>Total sales performance</p>
        </div>
        <div className="chart-card-actions">
          <div className="filter-group">
            {isMonthlyView && (
              <DashboardDatePicker
                mode="year"
                value={filterYear}
                onChange={(val) => {
                  setFilterYear(val);
                  loadChartData({
                    is_month_view: isMonthlyView ? "E" : "D",
                    year: val ? moment(val).format("YYYY") : null,
                  });
                }}
              />
            )}
            <ChartViewToggle
              leftLabel="Monthly"
              rightLabel="Annually"
              isRightActive={!isMonthlyView}
              onChange={(isAnnual) => {
                setIsMonthlyView(!isAnnual);
                loadChartData({
                  is_month_view: isAnnual ? "D" : "E",
                  year: filterYear ? moment(filterYear).format("YYYY") : null,
                });
              }}
            />
          </div>
          <div className="chart-controls">
            <button
              className={`chart-type-btn ${chartType === "line" ? "active" : ""}`}
              onClick={() => setChartType("line")}
            >
              <img src={chartType === "line" ? LineChartWhite : LineChartIcon} alt="Line" />
            </button>
            <button
              className={`chart-type-btn ${chartType === "bar" ? "active" : ""}`}
              onClick={() => setChartType("bar")}
            >
              <img src={chartType === "bar" ? BarChartIcon : BarChartClr} alt="Bar" />
            </button>
            <button
              className="refresh-btn"
              onClick={() => {
                setIsMonthlyView(true);
                setFilterYear(null);
                loadChartData({ is_month_view: "E", year: null });
              }}
            >
              <img src={RefresIcon} alt="Reset" />
            </button>
          </div>
        </div>
      </div>

      <div className="chart-card-body" style={{ height: "300px" }}>
        {renderChart && chartType === "bar" && (
          <Bar data={chartData} options={chartOptions} />
        )}
        {renderChart && chartType === "line" && (
          <Line data={chartData} options={chartOptions} />
        )}
      </div>
    </div>
  );
};

export default connect(null, { sendPostRequest })(SalesChart);
